import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getStorage, FirebaseStorage } from 'firebase/storage';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getDatabase, Database } from 'firebase/database';
import type { FirebaseConfig } from '../types';

// Firebase configuration from environment variables
const firebaseConfig: FirebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'missing-api-key',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'missing-auth-domain',
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL || 'missing-database-url',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'missing-project-id',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'missing-storage-bucket',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || 'missing-sender-id',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || 'missing-app-id',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || 'missing-measurement-id'
};

// Debug: Log configuration (without sensitive data)
console.log('Firebase Config Debug:');
console.log('API Key:', import.meta.env.VITE_FIREBASE_API_KEY ? 'SET' : 'MISSING');
console.log('Auth Domain:', import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ? 'SET' : 'MISSING');
console.log('Project ID:', import.meta.env.VITE_FIREBASE_PROJECT_ID ? 'SET' : 'MISSING');
console.log('Storage Bucket:', import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ? 'SET' : 'MISSING');
console.log('Messaging Sender ID:', import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ? 'SET' : 'MISSING');
console.log('App ID:', import.meta.env.VITE_FIREBASE_APP_ID ? 'SET' : 'MISSING');

// Check if we have the minimum required config
const hasValidConfig = import.meta.env.VITE_FIREBASE_API_KEY &&
                      import.meta.env.VITE_FIREBASE_AUTH_DOMAIN &&
                      import.meta.env.VITE_FIREBASE_PROJECT_ID;

if (!hasValidConfig) {
  console.error('Firebase Config Error: Missing required environment variables!');
  console.error('Please set the following environment variables:');
  console.error('- VITE_FIREBASE_API_KEY');
  console.error('- VITE_FIREBASE_AUTH_DOMAIN');
  console.error('- VITE_FIREBASE_PROJECT_ID');
  console.error('- VITE_FIREBASE_STORAGE_BUCKET');
  console.error('- VITE_FIREBASE_MESSAGING_SENDER_ID');
  console.error('- VITE_FIREBASE_APP_ID');
}

// Initialize Firebase
let app: FirebaseApp;
try {
  app = initializeApp(firebaseConfig);
  console.log('Firebase initialized successfully');
} catch (error) {
  console.error('Firebase initialization failed:', error);
  throw error;
}

// Initialize Firebase services
export const auth: Auth = getAuth(app);
export const storage: FirebaseStorage = getStorage(app);
export const db: Firestore = getFirestore(app);
export const realtimeDb: Database = getDatabase(app);

export default app; 